import React from "react"
import { Col, Row, Button } from "reactstrap"
import { T } from "../../traks"

export const PremiumCard = ({ headerTitle, headerIconSrc, detailsIconSrc, isPremiumCard, details, btnVars }) => {
    return (
        <div className={`card-container premium-border`}>
            <Row className={`premium-card ${isPremiumCard ? "premium-card-green" : "premium-card-red"} ad_signup_right_header`}>
                <span dangerouslySetInnerHTML={{ __html: headerIconSrc }} />
                <h3 className="premium-card-header fw_900">{headerTitle}</h3>
            </Row>
            {isPremiumCard && (
                <Row>
                    <span style={{fontStyle: 'italic', padding: '1px 0px 0px 20px'}}><T>All the features of the free version, plus the following:</T></span>
                </Row>
            )}
            {details.map((detail, index) => (
                <Row key={index} className="premium-card-detail">
                        <b className="ad_125pct mb-2">{detail.title}</b>
                    <Col sm="11">
                        {detail.entries.map((entry, entryIndex) => (
                            <Row>
                                <Col sm="1">
                                    <span className="premium-details-icon" dangerouslySetInnerHTML={{ __html: detailsIconSrc }} />
                                </Col>
                                <Col>
                                    <p key={entryIndex}>{entry}</p>
                                </Col>
                            </Row>
                        ))}
                    </Col>
                </Row>
            ))}
            <Row className="premium-card-button-container">
                <Button className={`ad_new_game_button ${isPremiumCard ? "premium-card-green" : "premium-card-red"}`} onClick={btnVars.onClick}>
                    {btnVars.btnText}
                </Button>
            </Row>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/c/Premium/PremiumCard.js